'use client';

import { clsx } from 'clsx';
import { FC, useState } from 'react';
import { Image } from 'atoms/Image/Image';
import { useMediaQuery } from 'modules/mui/hooks';
import { Accordion } from '../Accordion';
import { IAccordion } from '../types';
import styles from '../AccordionWithImage/styles.module.css';

export const AccordionWithImage: FC<IAccordion> = ({
  children,
  defaultExpanded = false,
  src,
  alt,
  id,
  ...accordionProps
}) => {
  const { isMobile } = useMediaQuery();
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

  return (
    <div id={id} className={styles.root}>
      {src && expanded && (
        <div className={styles.imageContainer}>
          <Image src={src} className={styles.image} alt={alt} />
        </div>
      )}

      <Accordion
        defaultExpanded={defaultExpanded}
        classes={{
          details: clsx(
            !src && isMobile && styles.mobileDetails,
            accordionProps?.classes?.details,
          ),
          summaryRoot: accordionProps?.classes?.summaryRoot,
        }}
        onChange={(e, exp) => {
          src && setExpanded(exp);
        }}
        {...accordionProps}
      >
        {children}
      </Accordion>
    </div>
  );
};
